import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/kis-aylarinda-uygulanan-mezoterapiler-soguk-havada-cilt-yenilenmesi/page.tsx");
